require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./commerces-1-1-18.json") })
        }
      }, "path---commerces-1-1-18");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---commerces-1-1-18!./.cache/json/commerces-1-1-18.json
// module id = 377
// module chunks = 231608221292675